import styled from 'styled-components';

export const ContainerPix = styled.div`
  display: flex;
  flex-direction: column;
  width: 89.333vw;
  gap: 3vw;
  margin-top: 2vw;
`;

export const LoadingGif = styled.img`
  width: 50vw;
  height: 50vw;
  align-self: center;
`;

export const ContainerMethodSelected = styled.div`
  display: flex;
  flex: none;
  font-family: 'Libre Franklin', sans-serif;
  align-items: center;
  background-color: #000000;
  color: #ffffff;
  border-radius: 2.666vw;
  height: 13.333vw;
  width: 89.333vw;
  margin: 0 0 6.666vw 0;
  p {
    font-size: 4.266vw !important;
    font-weight: 400 !important;
    width: 40.533vw;
    margin-left: 1.84vw !important;
    color: #ffffff;
    background-color: transparent;
  }
`;

export const ContainerIconMethod = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonModifyMethod = styled.button`
  background-color: transparent;
  border: none;
  color: white;
  font-family: 'Libre Franklin', sans-serif;
  font-size: 4.266vw;
  font-weight: 400;
  margin-left: 5vw;
`;

export const IconPix = styled.img`
  height: 7.2vw;
  width: 8.4vw;
  margin-left: 4.2vw;
`;

export const PixButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    width: 89.333vw;
    text-align: center;
    font-family: 'Libre Franklin', sans-serif;
    font-size: 3.468vw;
  }
`;

export const PixButtonCopy = styled.button`
  border: none;
  background-color: #f4f2f2;
  padding: 5.1vw 10.2vw 5.1vw 5.1vw;
  position: relative;
  font-family: 'Libre Franklin', sans-serif;
  font-size: 3.5vw;
  color: #c4c3c3;
  border-radius: 2.666vw;
  cursor: pointer;
  margin: 1rem 0 2rem 0;
  width: 89.333vw;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;

  span {
    color: black;
    font-weight: bold;
    text-align: center;
    margin-left: 20px;
  }
`;

export const CopyIcon = styled.img`
  background-color: transparent;
  position: absolute;
  width: 20px;
  right: 9px;
  top: 18px;
`;

export const ContainerQrCode = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
